import { Link } from "react-router-dom";
import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import { DashboardLayout } from "../../components/dashboard-layout";

function AdminHome() {
    const profile = JSON.parse(localStorage.getItem("profile") || "null");
    const roles = profile?.roles || {};
    const isFullAdmin = profile?.permission?.full === 1;
    const links = [
        { label: "Quản lý người chơi", to: "/admin/users", allowed: isFullAdmin || roles.user_customer },
        { label: "Lịch sử cược", to: "/admin/history", allowed: isFullAdmin || roles.hist_bet },
        { label: "Tài Xỉu 45s", to: "/admin/settx45s", allowed: isFullAdmin || roles.game_tx45 },
        { label: "Tài Xỉu 60s", to: "/admin/settx60s", allowed: isFullAdmin || roles.game_tx60 },
        { label: "Xóc Đĩa 45s", to: "/admin/setxd45s", allowed: isFullAdmin || roles.game_xd45 },
        { label: "Xóc Đĩa 60s", to: "/admin/setxd60s", allowed: isFullAdmin || roles.game_xd60 },
        { label: "Xổ Số 75s", to: "/admin/setxs75s", allowed: isFullAdmin || roles.game_xs75 },
        { label: "Xổ Số 120s", to: "/admin/setxs120s", allowed: isFullAdmin || roles.game_xs120 },
        { label: "Baccarat", to: "/admin/setbcr", allowed: isFullAdmin || roles.game_baccarat },
        { label: "Tỷ lệ game", to: "/admin/setting", allowed: isFullAdmin || roles.sys_odds },
        { label: "API key DG2", to: "/admin/dg2-keys", allowed: profile?.isAdmin === true },
        { label: "Quản lý MongoDB", to: "/admin/mongo-manager", allowed: profile?.isAdmin === true },
    ];
    const availableLinks = links.filter((link) => link.allowed);

    return (
        <DashboardLayout>
            <Box component="main" sx={{ py: 4, backgroundColor: "#F5F8FA", minHeight: "100vh" }}>
                <Container maxWidth="lg">
                    <Paper sx={{ p: { xs: 2, md: 4 } }}>
                        <Typography variant="h5" fontWeight={800}>Quản trị game</Typography>
                        <Typography color="text.secondary" sx={{ mt: 0.5, mb: 3 }}>
                            Chọn chức năng quản lý người chơi, trò chơi, lịch sử hoặc API key DG2.
                        </Typography>
                        {availableLinks.length ? (
                            <Stack direction="row" spacing={1.5} useFlexGap flexWrap="wrap">
                                {availableLinks.map((link) => (
                                    <Button
                                        key={link.to}
                                        component={Link}
                                        to={link.to}
                                        variant="outlined"
                                    >
                                        {link.label}
                                    </Button>
                                ))}
                            </Stack>
                        ) : (
                            <Typography color="text.secondary">
                                Tài khoản chưa được cấp quyền truy cập chức năng quản trị.
                            </Typography>
                        )}
                    </Paper>
                </Container>
            </Box>
        </DashboardLayout>
    );
}

export default AdminHome;
